var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProperty = function SvgProperty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08245 14.0974V21.2646H4.22245V14.0974H6.08245ZM6.50405 12.8574H3.79465C3.68776 12.8566 3.58177 12.8771 3.48286 12.9176C3.38394 12.9581 3.29408 13.0179 3.21849 13.0935C3.14291 13.1691 3.08311 13.2589 3.04259 13.3579C3.00206 13.4568 2.98162 13.5628 2.98245 13.6696V21.6986C2.98408 21.913 3.07037 22.118 3.22251 22.269C3.37465 22.4199 3.58031 22.5047 3.79465 22.5046H6.50405C6.71897 22.5047 6.92527 22.4202 7.0784 22.2693C7.23153 22.1185 7.31919 21.9135 7.32245 21.6986V13.6696C7.32245 13.5625 7.30124 13.4563 7.26003 13.3574C7.21883 13.2584 7.15845 13.1686 7.08237 13.0931C7.00629 13.0176 6.91602 12.9579 6.81677 12.9175C6.71751 12.877 6.61123 12.8566 6.50405 12.8574V12.8574Z",
    fill: "#ffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.832 17.8926V19.889C13.832 20.419 14.0422 20.9275 14.4164 21.3028C14.7906 21.6782 15.2984 21.8899 15.8284 21.8916H27.9742",
    stroke: "#ffff",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9743 8.55469H19.6973",
    stroke: "#ffff",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1126 16.5787C10.1126 16.5787 14.217 16.2687 14.992 12.4309L18.8236 14.1235C19.1969 14.2902 19.6193 14.3101 20.0066 14.1791C20.3939 14.0481 20.7176 13.7758 20.913 13.4167C21.0208 13.2224 21.0877 13.0081 21.1094 12.787C21.1311 12.5659 21.1073 12.3426 21.0393 12.1311C20.9713 11.9196 20.8606 11.7243 20.7141 11.5572C20.5676 11.3901 20.3884 11.2549 20.1876 11.1599L15.1222 8.76668C14.6214 8.52716 14.0618 8.43832 13.5114 8.51096C12.9611 8.58361 12.4437 8.81461 12.0222 9.17588L6.92578 13.5159",
    stroke: "#ffff",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58398 21.8789H11.7362",
    stroke: "#ffff",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4218 19.6171C18.0793 19.6171 18.6122 19.0842 18.6122 18.4267C18.6122 17.7693 18.0793 17.2363 17.4218 17.2363C16.7644 17.2363 16.2314 17.7693 16.2314 18.4267C16.2314 19.0842 16.7644 19.6171 17.4218 19.6171Z",
    fill: "#ffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0239 18.4189C26.6778 18.4189 28.0185 17.0782 28.0185 15.4243C28.0185 13.7704 26.6778 12.4297 25.0239 12.4297C23.37 12.4297 22.0293 13.7704 22.0293 15.4243C22.0293 17.0782 23.37 18.4189 25.0239 18.4189Z",
    fill: "#ffff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProperty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Property.95dcd7f0.svg";
export { ForwardRef as ReactComponent };